<div class="progressWrapper">
    <div class="progressContainer">
        <div class="progressElement" *ngFor="let progressBar of progressBars; trackBy: trackByIndex">
            <div class="progress">{{ progressBar['name'] + '-' + progressBar['progress'] + '%' }}</div>
            <mat-progress-bar color="primary" [value]="progressBar['progress']"></mat-progress-bar>
        </div>
    </div>
</div>
